<template>
    <div :class="`convention-teaser-info ${mode} ${isChild ? 'child' : ''}`">
        <typo v-if="convention.brochure" :name="isChild ? 'body-12-light' : 'body-12-light'">
            {{ dico.brochure }} :&nbsp;
        </typo>
        <typo v-if="convention.brochure" :name="isChild ? 'body-12-bold' : 'body-12-bold'">
            {{ convention.brochure }}
        </typo>
        <typo v-if="convention.brochure && convention.idcc" :name="typoMedium">
            &nbsp;-&nbsp;
        </typo>
        <typo v-if="convention.idcc" :name="typoMedium">
            {{ dico.idcc }}
        </typo>
        <typo v-if="convention.idcc" :name="typoMedium">
            {{ convention.idcc }}
        </typo>
        <convention-teaser-territories
            v-if="convention.territoryRange"
            :mode="mode"
            :territoryRange="convention.territoryRange"
            :territoryCodes="convention.territoryCodes"
        />
    </div>
</template>

<script>
import ConventionTeaserTerritories from "./ConventionTeaserTerritories.vue";

export default {
    components: { ConventionTeaserTerritories },
    props: ["convention", "mode"],
    computed: {
        dico() {
            return this.$privateDico.convention.teaser;
        },
        isChild() {
            return this.convention.parentConventionId;
        },
        typoMedium() {
            return this.isChild ? "body-12-medium" : "body-12-medium";
        },
    },
};
</script>

<style scoped lang="sass">

.convention-teaser-info
    color: white
    display: flex
    padding-left: 30px
    margin-top: 5px

.convention-teaser-info.search-result
    color: $color-secondary

.convention-teaser-info.dashboard
    color: $color-secondary
@media print
    .convention-teaser-info
        padding-left: 0
</style>
